import { combineReducers } from 'redux';

import drafts from './draft_reducer';
import popup from './popup_reducer';
import translations from './translation_reducer';
import settings from './settings_reducer';

const rootReducer = combineReducers({
    drafts,
    popup,
    translations,
    settings
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_app/drafts/reducers/index.js